import React, { useState } from 'react';
import { connect } from 'react-redux';
import classNames from 'classnames/bind';
import properties from '../../../../modules/ajio-util/properties';
import { signInCheck } from '../../../../components/common/CheckUserStatus';
import styles from './index.pcss';
import { editAddress } from '../../../actions/addressBook';
import { rushAddressBarEvents } from '../../../../modules/ga/GTMdatalayer';
import { updateUserAddress } from '../../../../actions/shared/miscellaneous';
import { createCookie } from '../../../../components/common/Cookie';
import { getGSTFlag, getGstEnhancementFlag } from '../../../../refresh/selectors/featureFlagsSelector';

function roundToSix(value = '') {
  if (value === '' || value === null || value === undefined) return '';

  const num = Number(value);
  if (!Number.isFinite(num)) return '';

  return Number(num.toFixed(6));
}

const cx = classNames.bind(styles);

const AddressList = props => {
  const {
    addressList  = {},
    luxe,
    fromCart,
    updateAddressOnCart,
    setShowAddressList,
    setShowAddressBarDialog,
    setAddressSelected,
    handleAddressUpdate,
    isFromPDPhase2 = false,
    setDefaultAddress,
    enableRushDelivery = false,
    chechRushAvailability,
    getLocationDetailsFromAddress = () =>{},
    selectPlace,
    fleek,
    setGeoTagFromCart,
    geoTagFromCart,
    rushDeliveryApplied,
    setIsAddAddress,
    enableGST = false,
    enableGstEnhancement = false,
    opeGSTAddressValidation,
    updateUserAddressAction,
    isBilling = false
  } = props;

  const {addresses = []} = addressList;
  const [viewMoreFlag, setViewMoreFlag] = useState(false);        //Rush feature state for showing all addresses or at most 3 addresses

  const imageBaseUrl = properties.getProperty('imageBaseUrl');
  let rushRecentSearches = JSON.parse(localStorage.getItem('rushRecentSearches')) || [];

  const updateAddress = async (address) => {
    // GST 3.0: a GST-registered address must never open the map/pinpoint flow,
    // even when it has no lat/long — it can only be selected
    const isGstAddress = enableGstEnhancement && !!address?.gstNumber;
    if(enableRushDelivery) {
      if(fromCart && !address?.latitude && !isGstAddress){               //address selected from cart but not geotagged
        setGeoTagFromCart(address?.id);
      }
      else{
        setGeoTagFromCart(false);
      }
    }
    if((fromCart && !isBilling) || Boolean(signInCheck())) {
      updateAddressOnCart({ addressId: address?.id, lat: roundToSix(address?.latitude), long: roundToSix(address?.longitude), enableRushDelivery });
    }
    setShowAddressList(false);
    setShowAddressBarDialog?.(false);
    setAddressSelected(true);
    if(enableRushDelivery && !(address.lat || address.latitude) && fromCart && rushDeliveryApplied && !isGstAddress) {      //fromCart added for triggering geotagging of old addresses only in cart flow
      const locationDetails = await getLocationDetailsFromAddress(address);
      if(selectPlace){  
         await selectPlace(locationDetails?.place_id, locationDetails, true, { addrType: 'Edit' });  
      }
      handleAddressUpdate && handleAddressUpdate({...address, lat: roundToSix(locationDetails.lat) , lng: roundToSix(locationDetails.lng) });
    } else {
      !isBilling && setDefaultAddress && setDefaultAddress({...address, defaultAddress: true});
      handleAddressUpdate && handleAddressUpdate(address);
    }
    if(enableRushDelivery){
      rushAddressBarEvents("selectRushAddress",{source:"saved_address_clicked",pincode:address?.postalCode});
      chechRushAvailability(address?.postalCode,{lat:(address?.latitude || address?.lat), long:(address?.longitude || address?.long || address?.lng)})
    }
    if (enableGST && opeGSTAddressValidation) {
      const {
        postalCode: pincode = '',
        formattedAddress: formattedAdd = '',
        addressPoc: addressPocName = '',
        id: addressId = '',
        firstName = '',
        lastName = '',
        line1 = '',
        line2 = ''
      } = address;
      const newformattedAdd = formattedAdd || `${line1}, ${line2}, ${pincode}`;
      const newAddressPocName = addressPocName || `${firstName} ${lastName}`;
      createCookie(
        'USER_ADDR',
        JSON.stringify({
          addressId,
          pincode,
          formattedAddress: newformattedAdd,
          addressPoc: newAddressPocName
        }),
        365
      );
      updateUserAddressAction({
        addressId,
        pincode
      });
      opeGSTAddressValidation();
    }
  }

  const AddressBlock = item => {
    const { address, viewMoreIndex } = item;
    const { addressPoc, defaultAddress, formattedAddress, state, postalCode, phone, id, gstNumber } = address;
    // GST 3.0: a GST-registered address → show a GST tag and hide the edit arrow
    // (it can be selected but not edited)
    const isGstAddress = enableGstEnhancement && !!gstNumber;
    if (enableRushDelivery && !viewMoreFlag && viewMoreIndex === 3) {
      return (
        <>
          <div className={cx('view-more-container-rush')} onClick={() => setViewMoreFlag(true)}>
            <span className={cx('view-more-text', { 'view-more-container-rush-fleek': fleek })}>
              View More
            </span>
            <img
              src={
                fleek
                  ? `${imageBaseUrl}/static/img/chevronDownRushFleek.svg`
                  : `${imageBaseUrl}/static/img/BlueChevronDown.svg`
              }
              alt="View more chevron-down"
              className={cx('view-more-chevron-Down-up')}
            />
          </div>
        </>
      );
    } else if (enableRushDelivery && !viewMoreFlag && viewMoreIndex > 2) {
      return <></>;
    }
    return (
      <>
        <div
          className={cx(
            'addressBlock-main-sec',
            luxe ? 'luxe-addressBlock-main-sec' : undefined,
            { 'addressBlock-main-sec-rush': enableRushDelivery },
            { 'addressBlock-main-sec-rush-fleek': fleek }
          )}
          onClick={() => {
            updateAddress(address);
          }}
          role='listitem'
        >
          <div className={cx('addressBlock-left')} role='button' tabIndex={0} aria-label={`${(defaultAddress) ? 'DEFAULT SELECTED.' : ''} ${addressPoc}, ${state} Postal Code - ${postalCode} Phone - ${phone}`}>
            <div className={cx('addressBlock-name-sec')} aria-hidden="true">
              {defaultAddress && !enableRushDelivery && (
                <p className={cx(luxe ? 'luxe-addressBlock-default' : 'addressBlock-default')}>
                  DEFAULT
                </p>
              )}
              <p
                className={cx('addressBlock-name', {
                  'addressBlock-name-rush-fleek': fleek && enableRushDelivery
                })}
              >
                {addressPoc}
              </p>
              {isGstAddress && (
                <p className={cx('addressBlock-gst')}>GST</p>
              )}
              {defaultAddress && enableRushDelivery && (
                <p
                  className={cx(
                    luxe && !enableRushDelivery ? 'luxe-addressBlock-default' : 'addressBlock-default',
                    'addressBlock-default-rush'
                  )}
                >
                  DEFAULT
                </p>
              )}
            </div>
            <div
              aria-hidden="true"
              className={cx('addressBlock-address', {
                'addressBlock-address-rush-fleek': fleek && enableRushDelivery
              })}
            >
              {' '}
              {formattedAddress}
            </div>
            <div className={cx('addressBlock-state-sec')} aria-hidden="true">
              <img
                src={`${`${properties.getProperty('imageBaseUrl')}/static/img/cart_location.svg`}`}
                alt="Location icon"
                className={cx('address-state-icon')}
                aria-hidden="true"
              />
              <span
                className={cx('addressBlock-state', {
                  'addressBlock-state-rush-fleek': fleek && enableRushDelivery
                })}
              >
                <span className={cx('addressBlock-state-text')}>{state}</span>
                {postalCode}
              </span>
              <img
                src={`${`${properties.getProperty('imageBaseUrl')}/static/img/cart_call.svg`}`}
                alt="Phone icon"
                className={cx('address-state-icon')}
                aria-hidden="true"
              />
              <p>{phone}</p>
            </div>
          </div>
          {!isGstAddress && (
            <div className={cx('addressBlock-right')} aria-hidden="true">
              <img
                src={`${`${properties.getProperty('imageBaseUrl')}/static/img/arrow_right.svg`}`}
                alt="Right Caret icon"
                className={cx('address-right-arrow')}
                aria-hidden="true"
              />
            </div>
          )}
        </div>
        {enableRushDelivery &&
          viewMoreFlag &&
          viewMoreIndex > 2 &&
          viewMoreIndex === addresses?.length - 1 && (
            <div className={cx('view-more-container-rush')} onClick={() => setViewMoreFlag(false)}>
              <span className={cx('view-more-text', { 'view-more-container-rush-fleek': fleek })}>
                View Less
              </span>
              <img
                src={
                  fleek
                    ? `${imageBaseUrl}/static/img/chevronUpRushFleek.svg`
                    : `${imageBaseUrl}/static/img/BlueChevronUp.svg`
                }
                alt="View more chevron-up"
                className={cx('view-more-chevron-Down-up')}
              />
            </div>
          )}
      </>
    );
  };
  
  return (
    <div
      className={cx(
        enableRushDelivery && (!rushRecentSearches || rushRecentSearches.length === 0)
          ? 'addresslist-main-sec-rush'
          : enableRushDelivery && rushRecentSearches.length > 0
          ? 'addresslist-main-sec-rush-noMargin'
          : isFromPDPhase2
          ? 'addresslist-main-sec'
          : ''
      )}
      role='list'
    >
      {' '}
      {/* if Rush is enabled -> if there is no recent Searches give margin-bottom else not */}
      {addresses?.length > 0 &&
        addresses.map((el, index) => {
          return <AddressBlock address={el} viewMoreIndex={index} />;
        })}
    </div>
  );
};

const mapDispatchToProps = (dispatch) => {
  return {
    setDefaultAddress: addressObj => {
        dispatch(editAddress(addressObj));
    },
    updateUserAddressAction: data => dispatch(updateUserAddress(data))
  };
};

const mapStateToProps = state => {
  const { cart = {} } = state;
  const enableGST = getGSTFlag(state);
  const enableGstEnhancement = getGstEnhancementFlag(state);
  return {
    rushDeliveryApplied: cart?.rushDeliveryApplied,
    enableGST,
    enableGstEnhancement
  };
};


const connector = connect(mapStateToProps, mapDispatchToProps);

export default connector(AddressList);